import type { TranslationKey } from "../locales";
import { LocalizedError, type LocalizedErrorOptions } from "./localized-error";

/**
 * The caller has sent more of these than the window allows. 429, code `too_many_requests`.
 */
export class TooManyRequestsError extends LocalizedError {
	readonly status = 429 as const;
	readonly code: string;

	constructor(key: TranslationKey = "general.too_many_requests", options?: LocalizedErrorOptions) {
		super(key, options);
		this.name = "TooManyRequestsError";
		this.code = options?.code ?? "too_many_requests";
	}
}
